import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgCamComponent} from './ng-cam/ng-cam.component';

const COMPONENTS = [
  NgCamComponent
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    COMPONENTS
  ]
})
export class NgCamModule {
}
